import React from 'react';
import { FormattedMessage } from 'react-intl';
import Styled from 'styled';
import PropTypes from 'prop-types';

import Checkbox from 'four-nets/ui-v2/form/checkbox/checkbox';
import { Site } from 'four-nets/site';

import defaultStyles from './checkboxes.scss';
import mobileStyles from './checkboxes-mobile-styles.scss';

interface Props {
    styles: typeof defaultStyles;
    onVendorChange: () => void;
    excludeVendor: boolean;
    onUsedChange: () => void;
    excludeUsed: boolean;
}

class CheckboxesDefault extends React.PureComponent<Props> {
    static contextTypes = {
        site: PropTypes.instanceOf(Site),
    };

    render() {
        const { styles, onVendorChange, excludeVendor, onUsedChange, excludeUsed } = this.props;
        const { site } = this.context;

        return (
            <div className={styles.checkboxes}>
                <label className={styles.label}>
                    <Checkbox iconStyle={{ image: styles.icon }} onChange={onVendorChange} value={!excludeVendor} />
                    <FormattedMessage id='NEW_GOODS'>
                        {msg => <span className={styles.labelText}>{msg}</span>}
                    </FormattedMessage>
                </label>
                <label>
                    <Checkbox iconStyle={{ image: styles.icon }} onChange={onUsedChange} value={!excludeUsed} />
                    {site && site.isGarden ? (
                        <FormattedMessage id='PRODUCTS_FROM_SECOND_HAND'>
                            {msg => <span className={styles.labelText}>{msg}</span>}
                        </FormattedMessage>
                    ) : (
                        <FormattedMessage id='PRODUCTS_FROM_BAZAAR'>
                            {msg => <span className={styles.labelText}>{msg}</span>}
                        </FormattedMessage>
                    )}
                </label>
            </div>
        );
    }
}

export const Checkboxes = Styled(defaultStyles)(CheckboxesDefault);
export const CheckboxesMobile: React.FC<Omit<Props, 'styles'>> = props => (
    <Checkboxes style={{ checkboxes: mobileStyles.checkboxes }} {...props} />
);
